import { render } from "./EReceipt.vue?vue&type=template&id=0c40efe2&scoped=true&ts=true"
import script from "./EReceipt.vue?vue&type=script&lang=ts"
export * from "./EReceipt.vue?vue&type=script&lang=ts"

import "./EReceipt.vue?vue&type=style&index=0&id=0c40efe2&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c40efe2"]])

export default __exports__